import { ItemData } from 'core/models/Template'

export const BURGERS_CATALOG_TITLE_KEY = 'burgersCatalog' as const

export type BurgersSelectedItems = ItemData[]
